


































































































































// @ts-ignore
import v8n from 'v8n';
import { Component, Vue } from 'vue-property-decorator';
import { authModule, bookingModule, snackModule } from '@/store';
import { ApiError, ConfirmationEmailRequest, Customer, User } from '@/api';
import ChangePassword from '@/components/auth/ChangePassword.vue';
import ManageSubscription from '@/components/frontend/ManageSubscription.vue';

@Component({
  components: { ChangePassword, ManageSubscription },
})
export default class extends Vue {
  loading: boolean = false;
  valid: boolean = false;
  success: boolean = false;
  error: string = '';

  tabs: number = 0;

  customer: Customer | null = null;
  user: User | null = null;

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  emailRules = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'Email address required',

    (v: string) =>
      v8n()
        .pattern(/\S+@\S+\.\S+/)
        .test(v) || 'Email address must be valid',
  ];

  get titles() {
    if (!bookingModule.titles) {
      return;
    }
    return bookingModule.titles;
  }

  async save() {
    if (!this.customer) {
      return;
    }

    try {
      this.loading = true;
      await this.customer.save();
      this.error = '';
      this.success = true;
    } catch (e) {
      this.success = false;
      this.error = e.response.errors[0].detail;
    } finally {
      this.loading = false;
    }
  }

  async resendConfirm() {
    if (!this.customer) {
      return;
    }
    try {
      const confirmEmail = new ConfirmationEmailRequest({
        email: this.customer.email,
      });
      await confirmEmail.save();
      snackModule.showSnackbar('Confirmation email sent.');
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async mounted() {
    if (!authModule.isLoggedIn) {
      this.$router.push({
        name: 'login',
        query: { next: window.location.pathname },
      });
    }
    if (authModule.user) {
      this.user = authModule.user;
      this.customer = authModule.user.customer;
    }
    if (this.$route.query.tab === 'subscribe') {
      this.tabs = 2;
    }
  }
}
